var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"dataset-cell-capitalize",class:[_vm.data.staticClass, _vm.props.class]},'div',_vm.data.attrs,false),[_vm._v(" "+_vm._s(_vm.props.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }